import DocumentViewModal from "./DocumentViewModal";

export default DocumentViewModal;
